export default "__VITE_ASSET__BWoqvBYQ__"